/**
 * Token Index ID Constants
 *
 * Use these constants instead of magic numbers when referencing specific indexes.
 * IDs are immutable database primary keys.
 *
 * Structure:
 * - id: internal identifier (immutable) - use for all logic
 * - slug: for URLs (mutable if renamed)
 * - on_chain_symbol: display value (mutable)
 */
export const TOKEN_INDEX_IDS = {
  /** All Market - on_chain_symbol: QAPEX */
  ALL_MARKET: 1,
  /** US Reserve - on_chain_symbol: QTREASURY */
  US_RESERVE: 2,
  /** The Big Three - on_chain_symbol: QINDEX */
  BIG_THREE: 3,
} as const;

export type TokenIndexId = typeof TOKEN_INDEX_IDS[keyof typeof TOKEN_INDEX_IDS];

/** Default token index to show when none selected */
export const DEFAULT_TOKEN_INDEX_ID = TOKEN_INDEX_IDS.BIG_THREE;
